import React from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'
import ArrowDown from './../../ArrowDown'
import createContextMenuRef from '@alastair/contextmenu'
import history from './../../../history'

const styles = {
  userWidget: {
    display: 'inline-block',
    position: 'relative',
    height: 34,
    lineHeight: '34px',
    marginLeft: 10,
    marginRight: 10,
  },
  avatar: {
    width: 34,
    height: 34,
    verticalAlign: 'middle',
  },
  inner: {
    display: 'block',
  },
  arrow: {
    verticalAlign: 'middle',
    padding: 10,
  },
  name: {
    verticalAlign: 'middle',
  },
}

const UserWidget = ({ classes, name, avatarUrl, className, logout }) => {

  var ContextMenu = ({ onClose }) => <div>
    <button onClick={() => {
      onClose()
      history.push('/login')
      logout()
      //()
    }}>Logout</button>
  </div>


  return <div className={classNames(classes.userWidget, className)}>

      <div className={classes.inner}
        ref={createContextMenuRef(ContextMenu)}
      >
        <span className={classes.name}>{name}</span>
        <ArrowDown className={classes.arrow} />
        <img className={classes.avatar} src={avatarUrl} />
      </div>

  </div>
}

export default injectStyles(styles)(UserWidget)


// WEBPACK FOOTER //
// ./src/modules/ControlBar/UserWidget/UserWidget.js